import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccessRole, DEFAULT_DATE_FORMAT, LoadingPanelService, LocalService, VisorComponent } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IGetUsuarioEmpresa } from '../../../../shared/interfaces/database/seguridad';
import { PortalUsuarioEmpresaService } from '../../../../services/database/portal-usuario-empresa.service';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { ButtonModule } from 'primeng/button';
import saveAs from 'file-saver';

@Component({
  selector: 'app-empresa-info',
  standalone: true,
  imports: [CommonModule, SkeletonModule, ButtonModule, VisorComponent],
  templateUrl: './empresa-info.component.html',
  styleUrl: './empresa-info.component.scss'
})
export class EmpresaInfoComponent implements OnInit {

  @Input() empresaId !: number;
  data !: IGetUsuarioEmpresa;
  isLoading: boolean = true;
  role = AccessRole;
  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;
  trans: any = {};

  @ViewChild(VisorComponent) visorDialog !: VisorComponent;
  
  constructor(private readonly _t: TranslateService, private readonly _ps: PortalUsuarioEmpresaService,
    private readonly _lps: LoadingPanelService, public ls: LocalService) {
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      correo: this._t.get('common.correo'),
      telefono: this._t.get('common.telefono'),
      direccion: this._t.get('common.direccion'),
      abrir: this._t.get('form.button.abrir'),
      descargar: this._t.get('common.descargar'),
      documento: this._t.get('common.documento'),
      nit: this._t.get('common.nit'),
      nombre: this._t.get('common.nombre'),
    }));
  }


  getEmpresaInfo() {
    if (!this.empresaId || this.data !== undefined)
      return;

    this.isLoading = true;
    this._ps.getUsuarioEmpresa(this.empresaId).subscribe({
      next: (data: IGetUsuarioEmpresa) => {
        this.data = data;
      }, complete: () => {
        this.isLoading = false;
      }
    });
  }

  downloadFormFile(saveFile: boolean) {
      this._lps.show(true);
      this._ps.downloadEmpresaDocumento(this.empresaId).subscribe({
        next: (response: Blob) => {
          this._lps.hide();
          if (response.size > 0) {
            if (saveFile)
              saveAs(response, this.data.nombre);
            else
              this.visorDialog.showDialog(response);
          }
        }
      });
    }

}
